import { SET_DISCOUNTS } from '../constants/Misc'

export default (state = {}, action) => {
  switch (action.type) {
    case SET_DISCOUNTS:
      return action.payload

    default:
      return state
  }
}

export const getDiscountsSelector = state => state.discounts
